import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import AnalyticsTracker from "./components/AnalyticsTracker";
import Home from "./components/Home";
import About from "./components/About";
import Vision from "./components/Vision";
import Videos from "./components/Videos";
import Contact from "./components/Contact";
import Private from "./components/Private";
import Events from "./components/Events";
import EventPage from "./components/EventPage";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import Checkout from "./components/Checkout";
import Payment from "./components/Payment";
import Login from "./components/Login/Login";
import AdminLayout from "./components/Admin/AdminLayout";
import AdminDashboard from "./components/Admin/AdminDashboard";
import AdminContact from "./components/Admin/AdminContact";
import AdminBlog from "./components/Admin/AdminBlog";
import AdminEvents from "./components/Admin/AdminEvents";
import AdminVideos from "./components/Admin/AdminVideos";
import AdminNotifications from "./components/Admin/AdminNotifications";
import { lazy, Suspense } from "react";
import PostWriter from "./components/PostWriter";
import { Routes, Route, Navigate } from "react-router-dom";
import './App.css';

// Code-split: keeps recharts out of the main bundle (admin-only page)
const AdminStats = lazy(() => import("./components/Admin/AdminStats"));

function App() {
  return (
    <div className="App">
      <AnalyticsTracker />
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/private-sessions" element={<Private />} />
        <Route path="/events" element={<Events />} />
        <Route path="/event/:slug" element={<EventPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/event/:slug/checkout" element={<Checkout />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/login" element={<Login />} />
        

        {/* Admin routes */}
        <Route path="/admin" element={<AdminLayout />}>
          {/* /admin */}
          <Route index element={<AdminDashboard />} />
          {/* /admin/contact */}
          <Route path="contact" element={<AdminContact />} />
          {/* /admin/blog */}
          <Route path="blog" element={<AdminBlog />} />
          <Route path="notifications" element={<AdminNotifications />} />
          {/* /admin/events */}
          <Route path="events" element={<AdminEvents />} />
          <Route path="videos" element={<AdminVideos />} />
          <Route
            path="stats"
            element={
              <Suspense fallback={<div style={{ padding: 24 }}>Loading…</div>}>
                <AdminStats />
              </Suspense>
            }
          />
        </Route>

        <Route path="/post-writer" element={<PostWriter />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
